let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("k3BGs"), load("leIbB"), load("bXkeF")]).then(() => parcelRequire('4rgwl'));